import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import { postDailyOppoAction } from '../../actions/dealDailyOpposPostAction';
import { AppLogo } from '../../constants/AppLogo';
import Error from '../error/Error';
import { regexObjectId } from '../../constants/formats';

const Opportunity = ({ postDailyOppo, oppoPost }) => {
  const { pending, success, error } = oppoPost;
  const { oppoId } = useParams();

  const [idError, setIdError] = useState('');

  useEffect(() => {
    if (!oppoId) {
      return;
    }

    if (!regexObjectId.test(oppoId)) {
      setIdError('Invalid opportunity');
      return;
    }

    postDailyOppo(oppoId, '', 'email');
  }, []);

  const renderContent = () => {
    if (idError) {
      return (
        <Box display='flex' alignItems='center' justifyContent='center'>
          <Typography variant='h6'>{idError}</Typography>
        </Box>
      );
    }

    if (pending) {
      return (
        <Box display='flex' alignItems='center' justifyContent='center'>
          <CircularProgress color='primary' size={22} style={{ marginRight: '1rem' }} />
          <Typography variant='h6'>Posting Deal</Typography>
        </Box>
      );
    }

    if (success) {
      return (
        <Box style={{ textAlign: 'center' }}>
          <Box style={{ marginBottom: '1rem' }}>
            <Typography variant='h6'>Complete</Typography>
            <Typography>Your deal has been posted</Typography>
          </Box>

          <Button
            component={Link}
            to='/deals'
            color='primary'
            variant='contained'
            style={{ marginRight: '1rem' }}
          >
            View in Partner Portal
          </Button>
          <Button color='primary' variant='outlined'>
            View in App
          </Button>
        </Box>
      );
    }

    return null;
  };

  return (
    <Container maxWidth='sm'>
      <Box justifyContent='center' style={{ padding: '3rem 0 2rem', textAlign: 'center' }}>
        <Box height='35px'>
          <AppLogo style={{ height: 35 }} />
        </Box>
      </Box>

      <Card>
        <CardContent>
          {Boolean(error) && <Error error={error} message={error} />}
          {renderContent()}
        </CardContent>
      </Card>
    </Container>
  );
};

Opportunity.propTypes = {
  postDailyOppo: PropTypes.func.isRequired,
  oppoPost: PropTypes.shape({
    // data: PropTypes.arrayOf(),
    pending: PropTypes.bool,
    error: PropTypes.string,
    success: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = (state) => ({ oppoPost: state.dealDailyOppoPost });
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ postDailyOppo: postDailyOppoAction }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Opportunity);
